import { render, staticRenderFns } from "./DatosEntradasComponent.vue?vue&type=template&id=3b13e274"
import script from "./DatosEntradasComponent.vue?vue&type=script&lang=js"
export * from "./DatosEntradasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports